<template>
	<div class="dashboard-container" :class="{ 'dashboard-dark': dashboardDark }">
		<Sidebar class="dashboard-sidebar" />
		<div class="dashboard-content" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
			<div class="scrollable-content">
				<Header />
				<div class="main-container">
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Header from '../components/layout/Header'
import Sidebar from '../components/layout/Sidebar.vue'
import { mapState } from 'vuex'

export default {
	name: 'Dashboard',
	components: { Header, Sidebar },
	computed: {
		...mapState(['sidebarCollapsed', 'dashboardDark']),
	},
	mounted: function() {
		this.syncDashboardTheme(this.dashboardDark)
		// Load account data after page reload
		this.$nextTick(function() {
			this.$store.dispatch('accountInfo')
		})
	},
	beforeDestroy() {
		document.body.classList.remove('dashboard-dark')
	},
	watch: {
		dashboardDark(newValue) {
			this.syncDashboardTheme(newValue)
		},
	},
	methods: {
		syncDashboardTheme(isDark) {
			document.body.classList.toggle('dashboard-dark', isDark)
		},
	},
}
</script>
<style scoped>
.dashboard-container {
	display: flex;
	height: 100vh;
	overflow: hidden;
	width: 100%;
}

.dashboard-sidebar {
	flex-shrink: 0;
}

.dashboard-content {
	flex: 1;
	margin-left: 280px;
	transition: margin-left 0.3s ease;
	display: flex;
	flex-direction: column;
	height: 100vh;
	overflow: hidden;
}

.dashboard-content.sidebar-collapsed {
	margin-left: 70px;
}

.scrollable-content {
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
}

.main-container {
	margin-bottom: 40px;
	padding: 0 15px;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
	.dashboard-content {
		margin-left: 0 !important;
	}

	.dashboard-content.sidebar-collapsed {
		margin-left: 0 !important;
	}
}
</style>
